// quizThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  SCHOOL_QUIZ_API_BASE_URL,
  SCHOOL_QUIZ_API_BASE_URL_new,
} from "../../../../src/configs/WebService";
import { apiKeyHeader } from "../../../configs/ApiKeys";

export const createQuiz = createAsyncThunk(
  "quiz/createQuiz",
  async (body, { rejectWithValue }) => {
    console.log(body.quiz_type);

    try {
      let res;
      if (body.quiz_type === 1 || body.quiz_type === 2) {
        res = await axios.post(
          `${SCHOOL_QUIZ_API_BASE_URL_new}/create-academic-quiz`,
          body,
          {
            headers: apiKeyHeader(),
          },
        );
      } else if (body.quiz_type === 3 || body.quiz_type === 4) {
        res = await axios.post(
          `${SCHOOL_QUIZ_API_BASE_URL_new}/create-theme-quiz`,
          body,
          {
            headers: apiKeyHeader(),
          },
        );
      } else {
      }

      return res.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const imageUpload = createAsyncThunk(
  "quiz/imageUpload",
  async ({ image, id, quiz_type }, { rejectWithValue }) => {
    try {
      // const res = axios.get(`${API_BASE_URL}/quizzes`);
      const formData = new FormData();
      formData.append("image", image);
      formData.append("quiz_type", quiz_type);
      const res = await axios.put(
        `${SCHOOL_QUIZ_API_BASE_URL}/quiz/${id}`,
        formData,
      ); // ✅ awai
      console.log(res);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);
export const getQuizzes = createAsyncThunk(
  "quiz/getQuizzes",
  async ({ quizType, schoolId }, { rejectWithValue }) => {
    try {
      // const url = `${SCHOOL_QUIZ_API_BASE_URL_new}/quizzes?type=${quizType}&school_id=${schoolId}&limit=${limit}&offset=${offset}`;
      const url = `${SCHOOL_QUIZ_API_BASE_URL_new}/quizzes?type=${quizType}&school_id=${schoolId}`;
      // const url = `${SCHOOL_QUIZ_API_BASE_URL}/quizzes?type=${quizType}`; // default
      const res = await axios.get(url);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const updateQuiz = createAsyncThunk(
  "quiz/updateQuiz",
  async (body, { rejectWithValue }) => {
    try {
      // const res = axios.get(`${SCHOOL_QUIZ_API_BASE_URL}/quizzes`);
      const res = await axios.put(
        `${SCHOOL_QUIZ_API_BASE_URL_new}/update-quiz`,
        body,
      ); // ✅ awai
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);
export const deleteQuiz = createAsyncThunk(
  "quiz/deleteQuiz",
  async ({ quiz_id, school_id, quizType, user_id }, { rejectWithValue }) => {
    try {
      const res = await axios.delete(
        // /school/delete-quiz/42?school_id=12840&quiz_type=1&user_id=101

        `${SCHOOL_QUIZ_API_BASE_URL_new}/delete-quiz/${quiz_id}?school_id=${school_id}&quiz_type=${quizType}&user_id=${user_id}`,
        // {
        //   data: { quiz_id, updated_by, quizType }, // 👈 body must be inside data
        // },
      ); // ✅ awai
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const publishOrUnpublish = createAsyncThunk(
  "quiz/publishOrUnpublish",
  async ({ id, quizType }, { rejectWithValue }) => {
    try {
      // const res = axios.get(`${SCHOOL_QUIZ_API_BASE_URL}/quizzes`);
      const res = await axios.post(
        `${SCHOOL_QUIZ_API_BASE_URL}/status-change?quiz_id=${id}&&quiz_type=${quizType}`,
      ); // ✅ awai
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const getRegisteredQuizUsersList = createAsyncThunk(
  "quiz/getRegisteredQuizUsersList",
  async ({ quizType, quizId }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        // `${SCHOOL_QUIZ_API_BASE_URL_new}/participants/${id}`,
        `${SCHOOL_QUIZ_API_BASE_URL_new}/quiz-participant/${quizId}?quiz_type=${quizType} `,
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

// 4 SEPT
export const getQuizParticipants = createAsyncThunk(
  "quiz/getQuizParticipants",
  async ({ quiz_id, limit = 10, offset }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${SCHOOL_QUIZ_API_BASE_URL}/live-quiz-participants?quiz_id=${quiz_id}&limit=${limit}&offset=${offset}`,
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const getAgeGroups = createAsyncThunk(
  "quiz/getAgeGroups",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${SCHOOL_QUIZ_API_BASE_URL}/get-age-groups`);
      return res.data;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);
export const getAvailableQuestionsCount = createAsyncThunk(
  "quiz/getAvailableQuestionsCount",
  async ({ class_id, subject_id }, { rejectWithValue }) => {
    try {
      // ✅ Only send class_id and subject_id in the request body
      const res = await axios.post(`${SCHOOL_QUIZ_API_BASE_URL}/get-count`, {
        class_id,
        subject_id,
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.error("❌ getAvailableQuestionsCount error:", err);
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const fetchQuizTypes = createAsyncThunk(
  "themes/fetchQuizTypes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${SCHOOL_QUIZ_API_BASE_URL}/get-quiztype`,
      );
      return response.data || [];
    } catch (error) {
      console.error("fetchClasses error:", error);
      return rejectWithValue("Failed to fetch subjects");
    }
  },
);

export const fetchThemes = createAsyncThunk(
  "themes/fetchThemes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${SCHOOL_QUIZ_API_BASE_URL}/themes`);
      return response.data || [];
    } catch (error) {
      console.error("fetchThemes error:", error);
      return rejectWithValue("Failed to fetch themes");
    }
  },
);

export const fetchSubjects = createAsyncThunk(
  "themes/fetchSubjects",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${SCHOOL_QUIZ_API_BASE_URL}/subjects`);

      // ✅ Extract subjects array properly
      const subjects = Array.isArray(response.data?.data)
        ? response.data.data
        : Array.isArray(response.data)
          ? response.data
          : [];

      // ✅ Filter only active ones
      const activeSubjects = subjects.filter((s) => s.status === 1);

      // ✅ Return with `data` key to match your component usage
      return { data: activeSubjects };
    } catch (error) {
      console.error("❌ fetchSubjects error:", error);
      return rejectWithValue("Failed to fetch subjects");
    }
  },
);

export const fetchSubjectBasedClassesData = createAsyncThunk(
  "schoolQuiz/fetchSubjectBasedClassesData",
  async ({ subject_id }, { rejectWithValue }) => {
    if (subject_id) {
      try {
        const response = await axios.get(
          `${SCHOOL_QUIZ_API_BASE_URL}/classes-by-subject/${subject_id}`,
        );
        if (response.data) {
          console.log(response.data);
          return response.data;
        } else {
          return rejectWithValue("Unable to delete class");
        }
      } catch (error) {
        console.error(error);
        return rejectWithValue(
          error.response?.data?.message || "deletion of law failed.",
        );
      }
    } else {
      return;
    }
  },
);
export const getStudentResults = createAsyncThunk(
  "schoolQuiz/getStudentResults",
  async ({ quizId, userId, quizType }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${SCHOOL_QUIZ_API_BASE_URL_new}/results?quiz_id=${quizId}&user_id=${userId}&quiz_type=${quizType}`,
        {
          headers: apiKeyHeader(),
        },
        // `${SCHOOL_QUIZ_API_BASE_URL}/classes-by-subject/${subject_id}`,
      );
      if (response.data) {
        console.log(response.data);
        return response.data;
      } else {
        return rejectWithValue("Unable to delete class");
      }
    } catch (error) {
      console.error(error);
      return rejectWithValue(
        error.response?.data?.message || "deletion of law failed.",
      );
    }
  },
);
export const getLeaderboardDetails = createAsyncThunk(
  "schoolQuiz/getLeaderboardDetails",
  async ({ quizId, quizType }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${SCHOOL_QUIZ_API_BASE_URL_new}/quizleaderboard/${quizId}?quiz_type=${quizType}`,
        {
          headers: apiKeyHeader(),
        },
        // `${SCHOOL_QUIZ_API_BASE_URL}/classes-by-subject/${subject_id}`,
      );
      if (response.data) {
        console.log("leaderboard", response.data);
        return response.data;
      } else {
        return rejectWithValue("Unable to delete class");
      }
    } catch (error) {
      console.error(error);
      return rejectWithValue(
        error.response?.data?.message || "deletion of law failed.",
      );
    }
  },
);
